import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Store } from '@ngxs/store';
import { DesignService } from './shared/services/design.service';
import { TenantService } from './shared/services/tenant.service';
import { TrackingService } from './shared/services/tracking.service';
import { GetAuthUser } from './auth/store';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { TRACKING_ITEM_TYPE } from './shared/types/tracking.type';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [HeaderComponent, RouterOutlet, FooterComponent]
})
export class AppComponent implements OnInit {
  protected router = inject(Router);
  private designService = inject(DesignService);
  private trackingService = inject(TrackingService);
  private tenantService = inject(TenantService);
  private store = inject(Store);

  menuItems = [
    { href: 'home', name: 'Home' },
    { href: 'help-topics', name: 'Help Topics' },
    { href: 'most-relevant', name: 'Most Relevant' },
    { href: 'faq', name: 'FAQs' }
  ];
  favIcon: HTMLLinkElement = document.querySelector('#favicon');

  constructor() {
    this.designService.setColorVariables(this.designService.getColorPalette());
    this.designService.setAssetsVariables(this.designService.getAssets());

    this.router.events.subscribe(res => {
      if (res instanceof NavigationEnd) {
        window.scrollTo(0, 0);
        if (!res.url.startsWith('/auth')) {
          void this.trackingService.addWCSTrackingItem(TRACKING_ITEM_TYPE.ROUTE, res.url);
        }
      }
    });

    if (this.tenantService.isTenantSE()) {
      this.favIcon.href = './../assets/favicons/cloud-icon-se.ico';
    } else if (this.tenantService.isTenantSHS()) {
      this.favIcon.href = './../assets/favicons/cloud-icon-shs.ico';
    } else {
      this.favIcon.href = './../assets/favicons/siemens-icon.ico';
    }
  }

  ngOnInit(): void {
    this.routeToRedirect();
    this.store.dispatch(new GetAuthUser());
  }

  private routeToRedirect(): boolean {
    const url = window.localStorage.getItem('redirectUrl');
    if (url) {
      void this.router.navigateByUrl(url);
      window.localStorage.removeItem('redirectUrl');
    }
    return !!url;
  }
}
